import React from 'react';
import { Button } from 'antd';
import styles from './index.module.scss';

const Btn = (props) => {
  return (
    <Button
      {...props}
      className={styles.btn}
    />
  );
};

const TaskAddedNotificationContent = ({ onCancel, onOk }) => {
  return (
    <>
      <span className={styles.title}>Вернуться к заявкам?</span>
      <span className={styles.actionContainer}>
        <Btn onClick={onCancel}>Нет</Btn>
        <Btn
          onClick={onOk}
          type="primary"
        >
          Да
        </Btn>
      </span>
    </>
  );
};

const taskAddedNotificationCN = styles.root;

export { taskAddedNotificationCN };
export default TaskAddedNotificationContent;
